import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-failure',
  standalone: true,
  imports: [
    TranslatePipe,
    ButtonComponent,
    NgOptimizedImage
  ],
  templateUrl: './failure.component.html',
  styleUrl: './failure.component.scss'
})
export class FailureComponent {

  constructor(private router: Router) {
  }

  public async restart() {
    await this.router.navigate(['/']);
  }

}
